import { render, staticRenderFns } from "./per-page-chooser.vue?vue&type=template&id=40e64c5d&scoped=true"
import script from "./per-page-chooser.vue?vue&type=script&lang=js"
export * from "./per-page-chooser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e64c5d",
  null
  
)

export default component.exports